module.exports = __webpack_public_path__ + "static/img/7.30c3bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/7.png
// module id = e8oK
// module chunks = 1